import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceDirectory from "./sections/ServiceDirectory";
import TheBlueprintJourney from "./sections/TheBlueprintJourney";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceDirectory />
      <TheBlueprintJourney />
      <Footer />
    </div>;
}